import React from 'react';
import { useArchitectureStore } from '../../store/useArchitectureStore';
import { Palette as PaletteIcon, Check } from 'lucide-react';
import { MOCK_PALETTES } from '../../data/palettes';

const ColorPaletteSystem: React.FC = () => {
    const { selectedPaletteId, setSelectedPaletteId } = useArchitectureStore();

    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2 text-stone-500 px-1">
                <PaletteIcon size={14} />
                <span className="text-xs font-bold uppercase tracking-widest">Material Palette</span>
            </div>

            <div className="grid grid-cols-1 gap-3">
                {MOCK_PALETTES.map(palette => {
                    const isSelected = selectedPaletteId === palette.id;
                    return (
                        <div
                            key={palette.id}
                            onClick={() => setSelectedPaletteId(palette.id)}
                            className={`p-3 rounded-xl border cursor-pointer transition-all group ${isSelected
                                    ? 'bg-stone-800 border-zinc-500 shadow-md'
                                    : 'bg-stone-900/40 border-stone-800 hover:bg-stone-900 hover:border-stone-700'
                                }`}
                        >
                            <div className="flex items-center justify-between mb-2">
                                <span className={`text-sm font-medium ${isSelected ? 'text-white' : 'text-stone-400 group-hover:text-stone-300'}`}>
                                    {palette.name}
                                </span>
                                {isSelected && <Check size={14} className="text-emerald-500" />}
                            </div>

                            {/* Color Swatches */}
                            <div className="flex gap-1 mb-2">
                                {palette.colors.map((color, i) => (
                                    <div
                                        key={i}
                                        className="w-6 h-6 rounded-full border border-white/10 shadow-sm"
                                        style={{ backgroundColor: color }}
                                        title={color}
                                    />
                                ))}
                            </div>

                            {/* Material Tags */}
                            <div className="flex gap-1 flex-wrap">
                                {palette.materials.slice(0, 3).map((mat, i) => (
                                    <span key={i} className="text-[9px] px-1.5 py-0.5 rounded bg-black/20 text-stone-500 border border-white/5">
                                        {mat}
                                    </span>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ColorPaletteSystem;
